import React, { useState, useEffect } from 'react';
import { Canvas } from '@react-three/fiber';
import Scribble from '../../Utils/Scribble.js';
import SceneComponent from './SceneComponent';
import { ModelList } from "../../Utils/ModelsList.js"
import LayerControl from './LayerControl'; // Import LayerControl component
import Measurements from '../../clickTools/Measurements.js';
import Info from '../../clickTools/Info.js';
import ColorChange from '../../clickTools/ColorChange.js';
import ObjectDetails from '../../clickTools/ObjectDetails.js';
import ImageViewer from './ImageViewer.js';
import Statistics from './Statistics.js';
import ScanViewer from './ScanViewer.js';
import { useProgress } from '@react-three/drei';
import { handleLogout } from '../../firebase/firebaseConfig.js';

const Presentation = () => {
  const { progress } = useProgress()

  const [currentSlide, setCurrentSlide] = useState(0);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isScribbleMode, setIsScribbleMode] = useState(false);
  const [selectedColor, setSelectedColor] = useState('black');
  const [previousSlideWasScene, setPreviousSlideWasScene] = useState(false);
  const [showDescription, setShowDescription] = useState(true); // Track description visibility
  const [showStatistics, setShowStatistics] = useState(false);
  const [statisticsType, setStatisticsType] = useState('none')
  const [showMeasurements, setShowMeasurements] = useState(true);
  const [isControlPanelCollapsed, setIsControlPanelCollapsed] = useState(false);
  
  // Automatically close sidebar on medium screens and below
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) { // Adjust the breakpoint as needed
        setIsSidebarOpen(false);
      }
    };

    // Initial check and add event listener
    handleResize();
    window.addEventListener('resize', handleResize);

    // Clean up the event listener on unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);




  useEffect(()=>{
    console.log('presentation refreshed')
  },
    [])


  // Define the slides, with some containing scene-specific content
  const slides = [
    { type: 'image', heading: 'MATALA GOLD', content: './presentation/3DMA.jpg' },
    {
      type: 'scene',
      heading: 'Overview of Matala Gold',
      content: {
        visibleObjects: ['Holes', 'Topo1m'],
        cameraPosition: [0, 3000,200],
        lookAt: [0, 0 , 0]
      }
    }
  ];

  const handleSlideClick = (index) => {
    setPreviousSlideWasScene(slides[currentSlide].type === 'scene');
    setCurrentSlide(index);
    setIsScribbleMode(false); // Disable scribble mode on page change
    
    setShowDescription(true)
    


    const newVisibility = { ...layerVisibility };
    
    // Reset all layers to invisible
    Object.keys(newVisibility).forEach((key) => {
      newVisibility[key].visible = false;
    });

    // Enable only the layers specified in the slide's visibleObjects
    const visibleObjects = slides[index]?.content?.visibleObjects || [];
    visibleObjects.forEach((name) => {
      if (newVisibility[name]) {
        newVisibility[name].visible = true;
      }
    });

    setLayerVisibility(newVisibility);
  };

  const handleToggleScribbleMode = () => {
    setIsScribbleMode(!isScribbleMode);
  };

  const renderSlideContent = () => {
    const slide = slides[currentSlide];
    switch (slide.type) {
      case 'image':
        return <img src={slide.content} alt="Slide" className="h-full w-full object-contain" />;

      case 'video':
        return (
          <video controls className="max-w-full max-h-full mx-auto">
            <source src={slide.content} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        );

      case 'youtube':
        return (
          <iframe
            width="100%"
            height="100%"
            src={slide.content}
            title="YouTube video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="max-w-full max-h-full mx-auto"
          ></iframe>
        );

      case 'scene':
        return null; // We render the Canvas separately for scene slides

      case '360':
        return null;

      default:
        return null;
    }
  };


  //////////LAYER VISIBILITY////////////////
  
  const [layerVisibility, setLayerVisibility] = useState({}); // Manage visibility of each layer
  const [showLayerControl, setShowLayerControl] = useState(false); // Toggle for Layer Control visibility
  
  useEffect(() => {
    const initialVisibility = {};
    ModelList.forEach((group) => {
      group.models.forEach((model) => {
        initialVisibility[model.name] = { visible: false, url: model.url };
      });
    });
    setLayerVisibility(initialVisibility);
  }, []);

   // Toggle visibility of layers from LayerControl
  const handleToggleVisibility = (modelName) => {
    setLayerVisibility((prevState) => ({
      ...prevState,
      [modelName]: {
        ...prevState[modelName],
        visible: !prevState[modelName].visible,
      }
    }));
  };

  const handleStatisticsTypeChange = (event) => {
    
    setStatisticsType(event.target.value);
    setShowStatistics(event.target.value !== "none")
    
  };

  
  

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar */}
      <div className={`transition-all duration-300 bg-black text-white h-full flex flex-col ${isSidebarOpen ? 'w-48' : 'w-12'}`}>
        <div className="relative flex justify-center mb-1 mt-1">
          <button
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-black p-1.5 rounded-full shadow-lg hover:from-yellow-400 hover:to-yellow-500 focus:outline-none transition-all duration-200 font-bold text-sm w-8 h-8 flex items-center justify-center"
          >
            {isSidebarOpen ? '←' : '→'}
          </button>
        </div>
        
        {/* {isSidebarOpen ?
        (<div className="mb-4">
          <label htmlFor="statisticsType" className="block text-white font-semibold mb-2">
            Select Statistics Type:
          </label>
          <select
            id="statisticsType"
            value={statisticsType}
            onChange={handleStatisticsTypeChange}
            className="w-full p-2 rounded bg-white text-black"
          >
            <option value="none">None</option>
            <option value="hoisting">Hoisting</option>
            <option value="development">Development</option>
            {/* Add more options if needed }
          </select>
        </div>):null
        } */}


        {isSidebarOpen ?(
          showStatistics?(
            <Statistics statisticsType={statisticsType} />
          ):
          (
            <div className="flex-1 overflow-y-auto p-1.5">
              <h2 className="text-xs font-bold mb-2 text-center text-yellow-400 drop-shadow-lg tracking-wide">MATALA GOLD</h2>
              <ul className="space-y-1">
                {slides.map((slide, index) => (
                  <li
                    key={index}
                    className={`flex items-center p-1.5 cursor-pointer ${index === currentSlide ? 'bg-gradient-to-r from-yellow-500 to-yellow-600 text-black' : 'bg-gray-700/80 hover:bg-gray-600/80'} transition-all rounded-md shadow-sm hover:shadow-md`}
                    onClick={() => handleSlideClick(index)}
                  >
                    <div className={`w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold ${index === currentSlide ? 'bg-yellow-300 text-black' : 'bg-gray-500 text-white'}`}>
                      {index + 1}
                    </div>
                    <span className="text-xs font-semibold ml-2 truncate">{slide.heading}</span>
                  </li>
                ))}
              </ul>
            </div>
          )
        ) : (
          <div className="flex-1 overflow-y-auto">
          <ul className="flex flex-col items-center space-y-2 mt-8 px-1">
            {slides.map((_, index) => (
              <li
                key={index}
                className={`w-6 h-6 flex items-center justify-center cursor-pointer rounded-full text-xs font-bold ${index === currentSlide ? 'bg-yellow-400 text-black shadow-lg' : 'bg-gray-500 text-white hover:bg-gray-400 shadow-sm'}`}
                onClick={() => handleSlideClick(index)}
              >
                {index + 1}
              </li>
            ))}
          </ul>
          </div>
        )}

        <div className="mt-auto p-1.5 border-t border-gray-700/70">
          <button
            onClick={handleLogout}
            className={`w-full flex items-center justify-center rounded-md font-semibold transition-all duration-200 ${
              isSidebarOpen
                ? 'bg-gray-700/80 hover:bg-gray-600/90 text-white text-xs py-1.5'
                : 'bg-gray-700 hover:bg-gray-600 text-white w-6 h-6 mx-auto rounded-full text-xs'
            }`}
            title="Logout"
          >
            {isSidebarOpen ? 'Logout' : '🔓'}
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-grow flex flex-col transition-all duration-300 relative overflow-hidden">
        {(slides[currentSlide].type === 'scene' || slides[currentSlide].type === '360') && progress < 100 && (
          <div className="fixed inset-0 z-40 flex flex-col items-center justify-center bg-gray-900 bg-opacity-90">
            <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
            <h1 className="mt-4 text-white text-xl font-semibold">Loading ...</h1>
            <p className="text-white text-lg">{progress.toFixed(0)}%</p>
          </div>
        )}
        <div className="flex-grow flex items-center justify-center bg-gray-400 overflow-hidden">
          {renderSlideContent()}
        </div>
        {/* Description Box */}
        {showDescription && slides[currentSlide].content.description && (
          <div className="absolute bottom-16 right-4   bg-gray-800 bg-opacity-70 text-white rounded-lg px-4 py-2 flex items-center space-x-2 z-50">
            <p className='self-center' dangerouslySetInnerHTML={{ __html: slides[currentSlide].content.description }}></p>
            <button
              onClick={() => setShowDescription(false)}
              className="text-gray-500 hover:text-gray-700 font-bold text-sm w-fit"
            >
              &times;
            </button>
          </div>
        )}

        


        {slides[currentSlide].type === 'scene' && (
          <>
            {/* Top Right Control Panel */}
            <div className="absolute top-1 right-1 sm:top-2 sm:right-2 bg-white border border-yellow-400 rounded shadow z-50 overflow-hidden">
              <div className="flex items-center justify-center p-1 border-b border-gray-200">
                <button
                  onClick={() => setIsControlPanelCollapsed(!isControlPanelCollapsed)}
                  className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center text-yellow-500 hover:text-yellow-600 transition-all duration-200"
                  title={isControlPanelCollapsed ? "Expand Controls" : "Collapse Controls"}
                >
                  <span className={`text-xs transition-transform duration-200 ${isControlPanelCollapsed ? '' : 'rotate-180'}`}>
                    ▼
                  </span>
                </button>
              </div>

              <div className={`transition-all duration-300 ease-in-out ${isControlPanelCollapsed ? 'max-h-0 opacity-0' : 'max-h-96 opacity-100'}`}>
                <div className="p-0.5 flex flex-col gap-0.5">
                  <button
                    onClick={handleToggleScribbleMode}
                    className={`w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center rounded-full shadow-sm hover:opacity-80 transition-all duration-200 ${
                      isScribbleMode ? 'bg-yellow-500 text-white' : 'bg-gray-500 text-white'
                    }`}
                    title="Toggle Scribble Mode"
                  >
                    <span className="text-xs">✏️</span>
                  </button>

                  <button
                    onClick={() => setShowLayerControl(!showLayerControl)}
                    className={`w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center rounded-full shadow-sm hover:opacity-80 transition-all duration-200 ${
                      showLayerControl ? 'bg-yellow-500 text-white' : 'bg-gray-500 text-white'
                    }`}
                    title="Layer Control"
                  >
                    <span className="text-xs">🗂️</span>
                  </button>

                  <button
                    onClick={() => setShowMeasurements(!showMeasurements)}
                    className={`w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center rounded-full shadow-sm hover:opacity-80 transition-all duration-200 ${
                      showMeasurements ? 'bg-yellow-500 text-white' : 'bg-gray-500 text-white'
                    }`}
                    title="Measurements Tools"
                  >
                    <span className="text-xs">🔧</span>
                  </button>
                </div>
              </div>
            </div>

            {/* Layer Control Panel */}
            {showLayerControl && (
              <LayerControl
                modelList={ModelList}
                layerVisibility={layerVisibility}
                onToggleVisibility={handleToggleVisibility}
              />
            )}

       
            <Canvas className="absolute inset-0" flat shadows gl={{ antialias: true }} camera={{ position: [0, 7000, 0], near: 0.5, far: 100000, fov: 35 }}>
              <SceneComponent
                currentSlide = {currentSlide}
                layerVisibility={layerVisibility} 
                cameraPosition={slides[currentSlide].content.cameraPosition}
                lookAt={slides[currentSlide].content.lookAt}
                animateCamera={previousSlideWasScene}
              />
            </Canvas>
            
            <Measurements showMeasurements={showMeasurements} />
            <ColorChange/>
            <ObjectDetails/>
            <Info/>
          </>



        )}

        {slides[currentSlide].type === '360' && (
          <>
            
              <ImageViewer imageUrl={slides[currentSlide].content.imageUrl}/>
            
          </>
        )}

        {slides[currentSlide].type === 'Scan' && (
          <>
            
              <ScanViewer url={slides[currentSlide].content.url} name={slides[currentSlide].content.name} />
            
          </>
        )}  

        {/* Scribble Component */}
        <Scribble
          isScribbleMode={isScribbleMode}
          selectedColor={selectedColor}
          onColorChange={setSelectedColor}
        />

        

        {/* Floating Navigation Buttons */}
        <button
          onClick={() => handleSlideClick((currentSlide - 1 + slides.length) % slides.length)}
          className="absolute bottom-6 left-16 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-black/70 text-yellow-300 shadow-xl ring-1 ring-yellow-500/40 transition hover:-translate-y-0.5 hover:bg-black/85 hover:text-yellow-200"
          title="Previous slide"
          aria-label="Previous slide"
        >
          &#8592;
        </button>
        <button
          onClick={() => handleSlideClick((currentSlide + 1) % slides.length)}
          className="absolute bottom-6 right-6 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-black/70 text-yellow-300 shadow-xl ring-1 ring-yellow-500/40 transition hover:-translate-y-0.5 hover:bg-black/85 hover:text-yellow-200"
          title="Next slide"
          aria-label="Next slide"
        >
          &#8594;
        </button>
      </div>
    </div>
  );
};

export default Presentation;
